import { useEffect, useState } from "react";

/**
 * Returns true when the viewport width is at or below `maxWidth` (default 640px,
 * Tailwind's `sm` breakpoint). Useful for switching behaviour that should only
 * differ on small screens (e.g. rendering a date picker in a portal on mobile
 * but anchored on desktop).
 *
 * Uses `window.innerWidth` (+ resize listener) rather than `matchMedia`, since
 * matchMedia can be unreliable under Chrome's device-emulation mode.
 */
export function useIsMobile(maxWidth = 640): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(
    () => typeof window !== "undefined" && window.innerWidth <= maxWidth
  );

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth <= maxWidth);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [maxWidth]);

  return isMobile;
}
